import React from 'react';
import _ from 'underscore';
import PropTypes from 'prop-types';
import { withStateStore } from '@bingads-webui/with-state-store';
import { helpers as urlHelpers } from '@bingads-webui/notification-service';
import { UnifiedNotificationQueue } from './unified-notification-queue';
import {
  setAPIConfig,
  getAllExternalNotifications,
  dismissAllExternalNotifications,
  onExternalNotificationsChange,
  unbindExternalNotifications,
  getPreviewBarVisibility,
  onPreviewBarVisibilityChange,
  unbindPreviewBarVisibility,
} from './unified-notification-queue-api';
import { contextPropTypes } from './constants';
import { getContext } from './utils';

export class UnifiedNotificationQueueShared extends React.Component {
  constructor(props) {
    super(props);

    const { notificationStore } = props;

    this.state = {
      externalNotifications: getAllExternalNotifications(),
      previewBarVisibility: getPreviewBarVisibility(),
      dismissAllExternalNotifications: () => {
        dismissAllExternalNotifications();
        notificationStore.dismissNQAll();
      },
    };

    this.isOnAccountsSummaryPage = urlHelpers.isOnAccountsSummaryPage();
  }

  componentDidMount() {
    setAPIConfig({ logger: this.props.logger });
    onExternalNotificationsChange(this.externalNotificationsChangeHandler);
    onPreviewBarVisibilityChange(this.previewBarVisibilityChangeHandler);
  }

  componentWillUnmount() {
    unbindExternalNotifications(this.externalNotificationsChangeHandler);
    unbindPreviewBarVisibility(this.previewBarVisibilityChangeHandler);
  }

  get shouldShowPreviewBar() {
    if (this.props.notificationStore.state.nQShouldShowPreviewBar === false) {
      return false;
    }
    return _.isUndefined(this.state.previewBarVisibility) ?
      this.props.shouldShowPreviewBar : this.state.previewBarVisibility;
  }

  get externalNotifications() {
    return _.union(
      this.state.externalNotifications,
      this.props.notificationStore.state.nQNotificationList
    );
  }

  externalNotificationsChangeHandler = (externalNotifications) => {
    this.setState({ externalNotifications });
  };

  previewBarVisibilityChangeHandler = (previewBarVisibility) => {
    this.setState({ previewBarVisibility });
  };

  render() {
    return (
      <UnifiedNotificationQueue
        {...this.state}
        context={getContext({ parameters: this.props.context })}
        externalNotifications={this.externalNotifications}
        i18n={this.props.i18n}
        ccBaseUrl={this.props.ccBaseUrl}
        logger={this.props.logger}
        generateViewAllLink={this.props.generateViewAllLink}
        isOnAccountsSummaryPage={this.isOnAccountsSummaryPage}
        PreviewBar={this.props.PreviewBar}
        shouldShowPreviewBar={this.shouldShowPreviewBar}
        permissions={this.props.permissions}
        isUINext={this.props.isUINext}
        goTargetPage={this.props.goTargetPage}
        getPathBySiteMapId={this.props.getPathBySiteMapId}
        baseHelpUrl={this.props.baseHelpUrl}
        whatsNewHelpQuery={this.props.helpParams && this.props.helpParams.query}
        helpParams={this.props.helpParams}
        MTNotificationFilter={this.props.MTNotificationFilter}
        setIsActive={this.props.setIsActive}
        forNewGlobalMenu={this.props.forNewGlobalMenu}
        triggerButtonRole={this.props.triggerButtonRole}
      />
    );
  }
}

UnifiedNotificationQueueShared.propTypes = {
  PreviewBar: PropTypes.node,
  shouldShowPreviewBar: PropTypes.bool,
  permissions: PropTypes.shape({}),
  context: PropTypes.shape({
    cid: contextPropTypes,
    aid: contextPropTypes,
    uid: contextPropTypes,
    campaignId: contextPropTypes,
  }),
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  ccBaseUrl: PropTypes.string.isRequired,
  isUINext: PropTypes.bool,
  logger: PropTypes.shape({
    mark: PropTypes.func,
    startProcess: PropTypes.func,
    endProcess: PropTypes.func,
    trace: PropTypes.func,
    error: PropTypes.func,
  }),
  generateViewAllLink: PropTypes.func,
  goTargetPage: PropTypes.func,
  getPathBySiteMapId: PropTypes.func,
  notificationStore: PropTypes.shape({
    dismissNQAll: PropTypes.func,
    state: PropTypes.shape({
      nQNotificationList: PropTypes.arrayOf(PropTypes.shape({})),
      nQShouldShowPreviewBar: PropTypes.bool,
    }),
  }),
  baseHelpUrl: PropTypes.string,
  helpParams: PropTypes.shape({
    project: PropTypes.string,
    language: PropTypes.string,
    asRow: PropTypes.number,
    query: PropTypes.string,
  }),
  MTNotificationFilter: PropTypes.func,
  setIsActive: PropTypes.func,
  forNewGlobalMenu: PropTypes.bool,
  triggerButtonRole: PropTypes.string,
};

UnifiedNotificationQueueShared.defaultProps = {
  logger: {
    mark: _.noop,
    startProcess: _.noop,
    endProcess: _.noop,
    trace: _.noop,
    error: _.noop,
  },
  permissions: {},
  PreviewBar: undefined,
  shouldShowPreviewBar: true,
  isUINext: false,
  context: {},
  generateViewAllLink: _.noop,
  goTargetPage: undefined,
  getPathBySiteMapId: undefined,
  notificationStore: {
    dismissNQAll: _.noop,
    state: {
      nQNotificationList: [],
      nQShouldShowPreviewBar: null,
    },
  },
  baseHelpUrl: '',
  helpParams: undefined,
  MTNotificationFilter: undefined,
  setIsActive: _.noop,
  forNewGlobalMenu: false,
  triggerButtonRole: '',
};

export function createUnifiedNotificationQueueSharedWithStateStore(stateStore) {
  return withStateStore(UnifiedNotificationQueueShared, stateStore, 'notificationStore');
}
